module.exports = __webpack_public_path__ + "static/media/swords.04627ea5.png";